/* eslint-disable eqeqeq */
import {useTranslation} from 'react-i18next'
import {Fragment, useEffect, useMemo} from 'react'
import {AsideMenuItem} from './AsideMenuItem'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {useAppSelector} from '../../../../redux/hooks'
import {authSelector} from '../../../../redux/slices/authSlices'

export function AsideMenuMain() {
  const {accessedMenu} = useAppSelector(authSelector)
  const {i18n} = useTranslation()
  const roleUser: any = localStorage.getItem('role-flag')
  
  const checkSector = () => {
    const _sectors = localStorage.getItem('sector_ids')?.split("|")
    return _sectors?.includes("1") || _sectors?.includes("3")
  }

  const menuGrouping = [
    {
      'key' : 'dashboard',
      'menus': ['dashboard']
    },
    {
      'key' : 'pi',
      'label': 'Pupuk Indonesia',
      'menus': ['management/order', 'management/sip', 'negotiate']
    },
    {
      'key' : 'anper',
      'label': 'Anak Perusahaan',
      'menus': [
        'management/kontrak',
        'management/so',
        'financial',
        'management/invoice',
        'management/do',
      ]
    }
  ]
  const orderedMenu = () => {
    let _menus: any[] = []
    accessedMenu?.forEach((menu: any) => {
      let found = {
        key: 'others',
        label: null
      };
      menuGrouping.forEach((group: any) => {
        if(group.menus.includes(menu?.menu?.uri)){
          found = group;
        }
      })

      const grouping = _menus.findIndex((find: any) => find.key == found.key)
      if(grouping >= 0){
        _menus[grouping].menus.push(menu);
      }else{
        _menus.push({
          key: found.key,
          label: found.label,
          menus: [
            menu
          ]
        })
      }
    })
    
    return _menus
  }

  return (
    <div id='asidediv'>
      {
        roleUser == 'salesAdmin' && checkSector() ? <>
          {
            orderedMenu()?.map((group: any, idx: number) => {
              return (
                <>
                  { group.label && <div className="menu-item">
                    <h4 className="menu-content text-muted mb-0 fs-7 text-uppercase">{ group.label }</h4>
                  </div> }
                  {group.menus?.map((item: any, index: number) => {
                    return (
                      <div id='asideiv' key={index}>
                        {item.menu?.sub_menu.length == 0 && item.read == true ? (
                          <MenuSingle item={item} i18n={i18n}/>
                        ) : item.menu.sub_menu.length > 0 && item.read == true ? (
                          <MenuWithSub item={item} i18n={i18n}/>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    )
                  })}
                  <div style={{height: 1, backgroundColor: '#9899ac'}}></div>
                </>
              )
            })
          }
        </> : <>
          {accessedMenu?.map((item: any, index: number) => {
            return (
              <div id='asideiv' key={index}>
                {item.menu?.sub_menu.length == 0 && item.read == true ? (
                  <MenuSingle item={item} i18n={i18n}/>
                ) : item.menu.sub_menu.length > 0 && item.read == true ? (
                  <MenuWithSub item={item} i18n={i18n}/>
                ) : (
                  <div></div>
                )}
              </div>
            )
          })}
        </>
      }
    </div>
  )
}


function MenuSingle(props: any) {

  return (
    <>
      <AsideMenuItem
        id={props.item.menu?.id}
        to={props.item.menu?.uri}
        title={props.i18n.language === 'en' ? props.item.menu?.name : props.item.menu?.name_ind}
        fontIcon={props.i18n.language === 'en' ? props.item.menu?.name : props.item.menu?.name_ind}
        icon={`/media/icons/duotune/${props.item.menu?.icon?.icon_path}`}
        detailMenu={props.item?.menu ?? null}
        detailMenuParent={props.item}
      ></AsideMenuItem>
    </>
  )
}

const MenuWithSub = (props: any)  => {
  const checkSubMenuHasFlag = (sub: any[]) => {
    const subFlags = sub.filter((item) => item.flag != null)
    return subFlags.length > 0 ? subFlags[0].flag : null
  }

  return (
    <>
      <AsideMenuItemWithSub
        id={props.item.menu?.id}
        to={props.item.menu?.uri}
        title={props.i18n.language === 'en' ? props.item.menu?.name : props.item.menu?.name_ind}
        fontIcon={props.item.menu?.uri}
        icon={`/media/icons/duotune/${props.item.menu?.icon?.icon_path}`}
        flag={checkSubMenuHasFlag(props.item.menu?.sub_menu)}
      >
        {props.item.menu?.sub_menu?.map((sub: any, subIndex: number) => {
          return (
            <Fragment key={subIndex}>
              {sub.read ? (
                <AsideMenuItem
                  id={sub?.id}
                  to={sub?.uri}
                  title={props.i18n.language === 'en' ? sub?.name : sub?.name_ind}
                  hasBullet={true}
                  detailMenu={sub ?? null}
                  detailMenuParent={props.item}
                  flag={sub?.flag}
                />
              ) : (
                <></>
              )}
            </Fragment>
          )
        })}
      </AsideMenuItemWithSub>
    </>
  )
}
